// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import utils from 'utility'
import Vuex from 'vuex'
import Constant from './constants/constant'
import store from './store/index'
import vueWechatTitle from 'vue-wechat-title'
import Cookies from 'js-cookie'

import wx from 'weixin-js-sdk'
// 按需引入组件

Vue.use(Vuex)
Vue.use(vueWechatTitle)
import { Popup, DatetimePicker, Toast, Tag, ImagePreview} from 'vant';
Vue.use(Popup).use(DatetimePicker).use(Toast).use(Tag).use(ImagePreview);

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js